import type { IntlShape } from 'react-intl';
import { defineMessage } from 'react-intl';
import { z } from 'zod';

const i18nMessages = {
  vanityNameAllowedCharacters: defineMessage({
    id: 'form-validators:error.vanity-name.allowed-characters',
    defaultMessage: 'Can only contain letters, numbers, dashes, underscores, and periods'
  }),
  vanityNameStartEndLetterNumber: defineMessage({
    id: 'form-validators:error.vanity-name.start-end-letter-number',
    defaultMessage: 'Must start and end with a letter or number'
  })
};

export interface VanityNameSchemaOptions {
  intl: IntlShape;
  min: number;
  max: number;
}

export const vanityNameSchema = ({ intl, min, max }: VanityNameSchemaOptions) =>
  z
    .string()
    .regex(/^[a-z0-9-_.]+$/i, intl.formatMessage(i18nMessages.vanityNameAllowedCharacters))
    .min(min)
    .max(max)
    .refine(
      val => /^[a-z0-9].*[a-z0-9]$/i.test(val),
      intl.formatMessage(i18nMessages.vanityNameStartEndLetterNumber)
    )
    .trim();
